import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { CustomDataTable } from "../../../../../components";
import { ERoutes } from "../../../../../ERoutes";
import { Link } from "react-router-dom";
import { DogBroodRequestApi, DogBroodRequestGridDto, DogBroodRequestSearch } from "../../../../../api";

export interface IDogLinkedBroodRequestsProps {
  dogId: number;
}

export const DogLinkedBroodRequests: React.FunctionComponent<IDogLinkedBroodRequestsProps> = ({ dogId }) => {
  const { t, tUnsafe } = useTl();
  const api = useApiService(DogBroodRequestApi);
  const { currentLanguage } = useGlobalData();

  const tableState = useGridState({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { requestNumber: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj: DogBroodRequestSearch) =>
      api.baseSearch(DogBroodRequestSearch.fromJS({ ...sObj, dogId: dogId, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId, dogId]
  );

  const { search, loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
        render: (row: DogBroodRequestGridDto) => (
          <Link target="_blank" to={`${ERoutes.broodRequest}/${row.broodRequestId}/detail/view`}>
            {row.requestNumber}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.RequestState),
        fieldName: "requestStatus",
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.BirthDate),
        fieldName: "birthDate",
      },
      {
        header: () => t(ETLCodes.DogStatus),
        fieldName: "dogTypeInRequest",
        render: (row: DogBroodRequestGridDto) => <div>{tUnsafe(row.dogTypeInRequest)}</div>,
      },
      {
        header: () => t(ETLCodes.Breeder),
        fieldName: "breeder",
        render: (row: DogBroodRequestGridDto) => (
          <Link target="_blank" to={`${ERoutes.people}/${row.breederId}/detail/view`}>
            {row.breeder}
          </Link>
        ),
      },
    ],
    [t, tUnsafe]
  );

  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <FieldSet title={t(ETLCodes.LinkedBroodRequests)}>
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
